import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "one_c" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1)
const _hoisted_4 = { class: "mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_rp_express_list_item = _resolveComponent("rp-express-list-item")!
  const _component_list = _resolveComponent("list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Реестр платежей (Ракета)" }),
      _createVNode(_component_the_button, {
        class: "primary small mr-2",
        onClick: _ctx.generateRP,
        loading: _ctx.state.is_generating
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode("Сформировать РП ")
        ]),
        _: 1
      }, 8, ["onClick", "loading"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.data_state.rp.is_failed && !_ctx.data_state.rp.failure.error_state.is_cancel)
        ? (_openBlock(), _createBlock(_component_failed_fetch, {
            key: 0,
            loading: _ctx.data_state.rp.is_loading,
            text: "При получении списка РП произошла ошибка",
            "error-message": _ctx.data_state.rp.failure.error_state.message,
            "error-url": _ctx.data_state.rp.failure.error_state.url,
            "error-status": _ctx.data_state.rp.failure.error_state.status,
            onRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadRPList(_ctx.data_state.rp.pagination.current_page)))
          }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
        : (_openBlock(), _createBlock(_component_list, {
            key: 1,
            loading: _ctx.data_state.rp.is_loading,
            items: _ctx.data_state.rp.list,
            pagination: "",
            "pagination-current-page": _ctx.data_state.rp.pagination.current_page,
            "pagination-total-pages": _ctx.data_state.rp.pagination.total_pages,
            onChangePage: _ctx.loadRPList
          }, {
            item: _withCtx(({ item }) => [
              _createVNode(_component_rp_express_list_item, { item: item }, null, 8, ["item"])
            ]),
            _: 1
          }, 8, ["loading", "items", "pagination-current-page", "pagination-total-pages", "onChangePage"]))
    ])
  ]))
}